// src/components/AppContext.js
import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [tournament, setTournament] = useState({name: "2. Internationaler Advents-Cup"});
  const [textOnScreen, setTextOnScreen] = useState('Welcome'); // Text on Screen
  // Zustand für die Items und das Turnier
  const [performingItem, setPerformingItem] = useState({});
  const [upcomingItem, setUpcomingItem] = useState({});
  const [resultItem, setResultItem] = useState({});
  return (
    <AppContext.Provider value={{ tournament, setTournament,  textOnScreen, setTextOnScreen, performingItem, setPerformingItem, upcomingItem, setUpcomingItem, resultItem, setResultItem }}>
      {children}
    </AppContext.Provider>
  );
};
